import ReactComponent from "./reactComponent";


export default class ReactContainer extends ReactComponent{
}

wx.comp = wx.comp || {};
wx.comp.ReactContainer = ReactContainer;
